import { MessageData } from 'generated/graphql';

import {
  GlAccountDataTable,
  SegmentedLabelTable
} from 'modules/components/layer25';



export type MessageDataTableProps = {
  messageData?: MessageData | null;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: MessageDataTableProps) => {
  if (!props.messageData) {
    return null;
  }

  const { type } = props.messageData;

  switch (type) {
    case null:
    case 'glAccount':
      return (
        <GlAccountDataTable.FC
          showLatest5Years
          data={props.messageData}
        />
      );
    case 'segmentedByLabel':
      return (
        <SegmentedLabelTable.FC data={props.messageData} />
      );

    case 'earningsCall':
    case 'economicIndex':
    default:
      return null;
  }
};
